import {Directive, Input} from '@angular/core';

@Directive({
  selector: '[ng-init]'
})
export class NgInitDirective {

  @Input('ng-init') ngInit;
  ngOnInit() {
    if (this.ngInit) {
      this.ngInit;
    }
  }
  constructor() { }

}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/directives/ng-init.directive.ts